import { ICheckBox } from 'Types/Common';
import { TitleList } from 'Types/Page/Reports';

export const REPORT_TITLE_LISTS: TitleList = [
  {
    _id: '1',
    cover: 'https://i.pinimg.com/736x/2b/78/3b/2b783b117941fba92b7a2ddabdba2f43.jpg',
    name: 'As if',
  },
  {
    _id: '2',
    cover: 'https://honeysanime.com/wp-content/uploads/2020/03/Ayaka-Ohashi-SS-1.jpg',
    name: 'NEW WORLD',
  },
  {
    _id: '3',
    cover:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQafmVj_1gJzWtQOL-TVUe5aBCk3oHvdLI2HNUmP_BnIvakfuNdy79JKIfGQsazzb0bIN0&usqp=CAU',
    name: 'Hallow',
  },
  {
    _id: '4',
    cover:
      'data:image/jpeg;base64,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',
    name: 'Winter is Coming',
  },
  {
    _id: '5',
    cover: 'https://mybride.net/wp-content/uploads/2020/07/japanese4.jpg',
    name: 'Pay phone',
  },
  {
    _id: '6',
    cover:
      'https://upload.wikimedia.org/wikipedia/commons/3/3f/Elisa_%28Japanese_singer%29_on_February_7%2C_2009.jpg',
    name: 'Let me know',
  },
  {
    _id: '7',
    cover: 'https://qph.fs.quoracdn.net/main-qimg-d8da28c9dc0425651104ae58e1322e5f',
    name: 'TELL ME',
  },
  {
    _id: '8',
    cover: 'https://i.pinimg.com/236x/e0/23/ce/e023ce964ebcdf137e974e8e721d2cc9.jpg',
    name: 'If it back',
  },
  {
    _id: '9',
    cover:
      'https://cdnb.artstation.com/p/assets/images/images/030/544/655/large/lcm-comics-lisa.jpg?1600918448',
    name: 'Dark Side',
  },
  {
    _id: '10',
    cover:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuAt3EdGql6scQYiUwvUHSlaSQhi_7WF2mag&usqp=CAU',
    name: 'When Moon',
  },
];

export default null;

export const miniCost = [
  {
    totalMoney1: 3000000,
    totalMoney2: 2000000,
  },
];

export const charheTypeData = [
  {
    chargeType: 'タイトルタイプA',
    quantity: '600',
    unitPrice1: '100',
    amountOfMoney1: '60000',
    rate: '6,0',
    amountOfMoney2: '51800',
    unitPrice2: '10.0',
    amountOfMoney3: ' 181275 ',
    totalCost: '118000',
  },
];

export const reportMock = [
  {
    ec1: '5,950',
    limit1: '8,075',
    app1: '220',
    total1: '14,245',
    ec2: '17,685,000',
    limit2: '22,682,500',
    app2: '799,920',
    total2: '41,167,420',
    productNumber: '1234',
    managementName: 'マスタ',
    artist: 'lyrical school',
    title: 'Wonderland',
    variation: '通常版',
    saleId: 'Aa73hie8fhdiwywhdkcpbjeXX',
    startDate: '6/23',
    sellPrice: '1,000',
    chargeType: 'タイトルタイプA',
    quantity: '500',
    unitPrice1: '100',
    amountOfMoney1: '50000',
    unitPrice2: '60',
    amountOfMoney2: '30000',
    unitPrice3: '10.0',
    amountOfMoney3: '500000',
    totalCost: '80000',
    saleDate: '6/1',
    buyer: 'miim_user_id_xxx',
  },
];

export const cardLeftDashboard = [
  { title: 'Sale', price: 34569, percent: 100, value1: 'test', value2: 'test' },
  { title: 'Enjoy', price: 4569, percent: 25.2, value1: 'test', value2: 'test' },
];

export const cardRightDashboard = [
  { title: 'Gift', price: 3605, percent: 10.4, value1: 'test', value2: 'test' },
  { title: 'Audition', price: 1569, percent: 5.2, value1: 'test', value2: 'test' },
];

export const viewPermissionTypes: ICheckBox[] = [
  {
    label: '担当アーティストのみ',
    value: 0,
    subLabel: '担当するアーティストのみ閲覧及び登録/変更ができます。',
    checked: false,
  },
  {
    label: 'すべて',
    value: 1,
    subLabel:
      '登録/変更は担当アーティストのみですが、全てのアーティストの閲覧ができます\n全てのアーティストに関する確認メールを受信します。',
    checked: false,
  },
];

export const viewPermissionTypesEcCompanyMasterRole: ICheckBox[] = [
  {
    label: 'すべて',
    value: 1,
    subLabel: '管理画面、イベント管理アプリ全ての機能が利用可能です。',
    checked: false,
  },
  {
    label: 'イベント管理アプリのみ',
    value: 0,
    subLabel:
      'イベント管理アプリのみ利用可能です。\n イベント管理アプリで閲覧、操作できるのは担当店舗のみとなります。',
    checked: false,
  },
];

export const CARDBUYFREE = '100';
export const TAXFEE = '6.0';

export const costInformationList = [
  {
    titleType: 'タイプ A',
    maxSongCount: '4',
    minPrice: '1000',
    maxVariationStorage: '150',
    limitTokutenStorage: '15',
    cardBuyFee: CARDBUYFREE,
    taxFee: TAXFEE,
    deletable: false,
  },
  {
    titleType: 'タイプ B',
    maxSongCount: '8',
    minPrice: '1500',
    maxVariationStorage: '300',
    limitTokutenStorage: '30',
    cardBuyFee: CARDBUYFREE,
    taxFee: TAXFEE,
    deletable: false,
  },
  {
    titleType: 'タイプ C',
    maxSongCount: '13',
    minPrice: '2000',
    maxVariationStorage: '600',
    limitTokutenStorage: '60',
    cardBuyFee: CARDBUYFREE,
    taxFee: TAXFEE,
    deletable: false,
  },
  {
    titleType: 'タイプ D',
    maxSongCount: '22',
    minPrice: '2500',
    maxVariationStorage: '820',
    limitTokutenStorage: '82',
    cardBuyFee: CARDBUYFREE,
    taxFee: TAXFEE,
    deletable: false,
  },
  {
    titleType: 'タイプ E',
    maxSongCount: '27',
    minPrice: '3000',
    maxVariationStorage: '2048',
    limitTokutenStorage: '200',
    cardBuyFee: CARDBUYFREE,
    taxFee: TAXFEE,
    deletable: false,
  },
];

export const optionChartDashboard = [
  { title: 'sale', subtitle: 'miimカード販売数', dataIndex: 'saleNumber' },
  { title: 'enjoy', subtitle: 'miimカード購入者視聴数', dataIndex: 'enjoyNumber' },
  { title: 'gift', subtitle: 'ギフト回数', dataIndex: 'giftNumber' },
  { title: 'audition', subtitle: 'ギフト受領者視聴数', dataIndex: 'auditionNumber' },
];

export const reportOption = {
  MONTH: 0,
  DAILY: 1,
  DETAIL: 2,
};
